// extracted by mini-css-extract-plugin
export default {"buyerRelationshipPage":"iFG8SWqhOBDQR6257mR1__buyerRelationshipPage___","pageContent":"ZHAyXvRMR_q7qzsbbj5c__pageContent___","nav":"Sq0xt9Q68YjYMmcnQAZw__nav___"};